import { TaskResultItemResponse } from 'compliance-api';
import dayjs from 'dayjs';
import capitalize from 'lodash/capitalize';
import lowerCase from 'lodash/lowerCase';
import { useCallback, useContext } from 'react';
import Badge from '@/modules/common/components/Badge.tsx';
import TaskResultInfoModalWithLoading from '@/modules/admin-dashboard/components/modals/TaskResultInfoModalWithLoading.tsx';
import { UpdateTaskModal } from '@/modules/admin-dashboard/components/modals/UpdateTaskModal.tsx';
import { Avatar, ModalProviderContext } from 'ui';
import { CalendarGreyIcon, FormSubGrayIcon, TaskGreyIcon } from 'ui/icons';

interface FormItemComplianceProgressItemProps {
  item: TaskResultItemResponse;
}

const FormItemComplianceProgressItem = ({ item }: FormItemComplianceProgressItemProps) => {
  const { openModal } = useContext(ModalProviderContext);
  const { user, form, label, selected, date, task, results } = item;

  const handleOpenTaskResultsModal = useCallback(() => {
    openModal(TaskResultInfoModalWithLoading, {
      resultId: item.task_result_id,
      taskId: task.id,
      user,
    });
  }, [item.task_result_id, openModal, task.id, user]);

  const handleOpenTaskModal = useCallback(() => {
    openModal(UpdateTaskModal, { id: task.id, defaultDisabled: true });
  }, [openModal, task.id]);
  return (
    <div className="space-y-1.5">
      <div className="flex justify-between">
        <div className="flex gap-2 items-center">
          <Avatar
            size="sm"
            classNameLetters="text-sm"
            firstName={user.first_name}
            lastName={user.last_name}
            src={user.avatar_url}
          />
          <div className="text-xs text-neutral-600">
            {user.first_name} {user.last_name}
          </div>
        </div>
        <div className="flex gap-2">
          {results.map(result => (
            <Badge type="info" key={result}>
              {capitalize(lowerCase(result))}
            </Badge>
          ))}
        </div>
      </div>
      <div className="font-semibold text-sm">{label}</div>
      <div className="text-sm">
        <span className="text-neutral-600">Selected option: </span>
        <span className="font-semibold">{selected.join(', ')}</span>
      </div>
      <div className="grid grid-cols-3">
        <div
          className="flex gap-2 items-center text-xs text-neutral-600 hover:underline cursor-pointer"
          onClick={handleOpenTaskResultsModal}
        >
          <img alt="" src={FormSubGrayIcon} width={20} />
          {form.name}
        </div>
        <div className="flex gap-2 items-center">
          <img alt="task" src={TaskGreyIcon} width={20} />
          <div
            className="text-xs text-neutral-600 hover:underline cursor-pointer"
            onClick={handleOpenTaskModal}
          >
            {task.name}
          </div>
        </div>
        <div className="flex gap-2 items-center">
          <img alt="" src={CalendarGreyIcon} width={20} />
          <span className="text-xs text-neutral-600">
            {dayjs(date).format('DD-MM-YYYY, HH:mm')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default FormItemComplianceProgressItem;
